import React, { Component } from 'react'; 
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import ResetPasswordForm from './ResetPasswordForm';
class ResetPasswordApp extends Component {
  constructor() {
    super();
    this.state = { 
    };
  } 

componentDidMount(){ 

}
 

  render() {
    return (
        <div className="container-xxl bg-white p-0">          
          <Spinner/>
          <TopMenu/>
          <ResetPasswordForm/> 
          <Footer />
        </div>
    );
  }
}

export default ResetPasswordApp;
